import React from 'react';
import { FadeIn } from './FadeIn';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Necesito saber de física?',
    a: 'No, RENACER traduce la ciencia en pasos prácticos.'
  }, {
    q: '¿Es inmediato?',
    a: 'Sí, recibes el acceso a RENACER en tu correo al instante.'
  }];
  return <section className="py-24 px-4 relative border-t border-sand bg-parchment-dark/50" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-center mb-12 text-brown-heading" data-id="element-33">
            Preguntas <span className="gold-gradient-text" data-id="element-34">Frecuentes</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-36">
              <div className="bg-parchment border border-sand rounded-xl p-6 hover:border-gold/30 transition-colors" data-id="element-37">
                <h3 className="text-lg font-semibold text-gold-antique mb-2" data-id="element-38">
                  {faq.q}
                </h3>
                <p className="text-brown-warm" data-id="element-39">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};